import { LoadingIcon } from '@/components/ui+/LoadingIcon';

export const PageLoading = () => {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <LoadingIcon />
    </div>
  );
};
